<script>
export default
{
    name: 'labelled-separator',

    props:
    {
        label: { type: String, required: true },
        orientation: { type: String, default: 'horizontal' }
    },

    created ()
    {
    },

    render () 
    {
        return (
            <div class={`labelled-separator ${this.orientation}`}>
                <div class='line' />
                <div class='text'>{ this.label }</div>
                <div class='line' />
            </div>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
    },

    methods:
    {
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.labelled-separator
{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    &.horizontal
    {
        flex-direction: row;
        margin: 2vh 0;

        .OnTablet({ margin: 1.2vh 0; });

        .line
        {
            width: 100%;
            height: 1px;
        }

        .text
        {
            margin: 0 20px;
        }
    }

    &.vertical
    {
        flex-direction: column;

        .line
        {
            width: 1px;
            height: 100%;
            background-color: var(--theme-border-color-strong);
        }

        .text
        {
            margin: 7px 0;
        }
    }

    .line
    {
        background-color: var(--theme-border-color);
    }

    .text
    {
        color: var(--theme-border-color-extra-strong);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/LabelledSeparator.vue